<template>
	<div class="as_stepper">
		<div class="row">
			<div class="col-lg-10 offset-lg-1 col-md-10 offset-md-1 col-sm-12 col-xs-12">
				<div class="row">
					<hr class='as_stepper_binder'>
					<div class="col stepper-step"  :class="{ selected : step==1}">
						<div class="circle stepper-step-deactivated">
							<i class='fa' :class="class_step_1"></i>
						</div>
						<h3>Seu consórcio</h3>
					</div>
					<div class="col stepper-step"  :class="{ selected : step==2}">
						<div class="circle stepper-step-deactivated" >
							<i class='fa fa-star'></i>
						</div>
						<h3>Oportunidades</h3>
					</div>											
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		props:['step'],
		computed:{
			class_step_1: function(){
				if (this.step > 1) return 'fa-check';
				return 'fa-bookmark';
			},		
		},
	}
</script>
